"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartItemDescriptionEnum = void 0;
var CartItemDescriptionEnum;
(function (CartItemDescriptionEnum) {
    CartItemDescriptionEnum["RESERVATION_ADDON"] = "reservation_addon";
    CartItemDescriptionEnum["SLOT_ADDON"] = "slot_addon";
    CartItemDescriptionEnum["HOUR_ADDON"] = "hour_addon";
    CartItemDescriptionEnum["RESERVATION_TYPE_RENTAL"] = "reservation_type_rental";
    CartItemDescriptionEnum["RESERVATION_TYPE_LESSON"] = "reservation_type_lesson";
    CartItemDescriptionEnum["GOODS"] = "goods";
})(CartItemDescriptionEnum = exports.CartItemDescriptionEnum || (exports.CartItemDescriptionEnum = {}));
//# sourceMappingURL=cart-item.enums.js.map